module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/arrow-back.254f03f6.svg";